import Service from "./Service";
const baseurl = '/api/historia-odontograma';
export default {
    index() {
        return Service.get(`${baseurl}`);
    },
    store(obj) {
        return Service.post(`${baseurl}/store`, obj);
    },
    storeGraphics(obj) {
        return Service.post(`${baseurl}/store-graphics`, obj);
    },
    show(id) {
        return Service.get(`${baseurl}/show/${id}`);
    },
    update(obj) {
        return Service.put(`${baseurl}/update`, obj);
    },
    showByHc(id) {
        return Service.get(`${baseurl}/show-by-hc/${id}`);
    },
    showByIdUsuario(id) {
        return Service.get(`${baseurl}/show-by-usuario/${id}`);
    },
}